export const getChartbeatConversion = `
    class ChartbeatConversionEvents {
      constructor() {
        this.isAttached = false;
        this.observer = null;
        this.originalPushState = history.pushState;
        this.init();
      }

      // Form finders
      findRegForm() {
        // Return the iframe container since we can't access cross-origin iframe content
        const form = document.getElementById('voltax-auth-openpass');
        const iframe = form?.querySelector('iframe');
        return iframe || null;
      }

      findNewsletterForm() {
        return document.getElementsByClassName('bcForm')[0]?.querySelector('input[type="text"]') || null;
      }

      // Track event helper
      track(eventName) {
        if (typeof window.chartbeat === 'function') {
          chartbeat(eventName);
        }
      }

      // Creates a tracker with start/complete/cancel state management
      createTracker(prefix) {
        let hasShown = false;
        let hasStarted = false;
        let hasCompleted = false;
        let hasCanceled = false;
        
        return {
          shown: () => { hasShown = true; this.track(prefix + 'Shown'); },
          start: () => { hasStarted = true; this.track(prefix + 'Start'); },
          complete: () => { hasCompleted = true; if (hasStarted) this.track(prefix + 'Complete'); },
          cancel: () => { 
            if (hasShown && !hasCompleted && !hasCanceled) {
              hasCanceled = true;
              this.track(prefix + 'Cancel');
            }
          }
        };
      }

      // Registration Wall tracking
      setupRegistrationTracking(regForm) {
        const reg = this.createTracker('trackRegistration');
        reg.shown();
        
        // Start: any auth button click or openpass form
        regForm.querySelectorAll('.voltax-auth-button, .voltax-auth-google-button')
          .forEach(btn => btn.addEventListener('click', reg.start, { once: true }));

        // OpenPass iframe tracking
        const iframe = regForm.querySelector('#voltax-auth-openpass').querySelector('iframe');
        if (!iframe) {
          return;
        }
        
        let hasInteracted = false;
        // Only event that is triggered when the user is interacting with the iframe
        iframe.addEventListener('mouseenter', () => {
          hasInteracted = true;
          reg.start();
        }, { once: true });

        // Complete: when "voltax_auth_provider" is set in local storage
        // Cancel: when modal closes without completing (modal removed from DOM)
        const regObserver = new MutationObserver(() => {
          if (localStorage.getItem('voltax_auth_provider')) {
            reg.complete();
            regObserver.disconnect();
          } else if (!iframe.isConnected) {
            reg.cancel();
            regObserver.disconnect();
          }
        });
        regObserver.observe(document.body, { childList: true, subtree: true });
        
        // Cancel: leave page without completing (user navigates away)
        window.addEventListener('beforeunload', reg.cancel);
      }

      // Newsletter tracking
      setupNewsletterTracking(newsletterForm) {
        const nl = this.createTracker('trackNewsletterSignup');
        nl.shown();
        
        const emailInput = newsletterForm.querySelector('input[type="text"]');
        const submitBtn = newsletterForm.querySelector('.blueConicButton input[type="submit"]');
        
        // Start: focus email input
        if (emailInput) {
          emailInput.addEventListener('focus', nl.start, { once: true });
        }
        
        // Complete: form submit or button click
        newsletterForm.addEventListener('submit', nl.complete, { once: true });
        if (submitBtn) {
          submitBtn.addEventListener('click', nl.complete, { once: true });
        }
        
        // Cancel: leave page, URL change (finite scroll), or form is removed from DOM
        window.addEventListener('beforeunload', nl.cancel);
        window.addEventListener('popstate', nl.cancel);
        
        // Cancel: when modal closes without completing (form removed from DOM)
        const nlObserver = new MutationObserver(() => {
          if (!newsletterForm.isConnected) {
            nl.cancel();
            nlObserver.disconnect();
          }
        });
        nlObserver.observe(document.body, { childList: true, subtree: true });
        
        const originalPushState = this.originalPushState;
        history.pushState = function(...args) {
          nl.cancel();
          return originalPushState.apply(history, args);
        };
      }

      attachListener() {
        if (this.isAttached) return;
        
        const regForm = this.findRegForm();
        const newsletterForm = this.findNewsletterForm();
        
        if (typeof window.chartbeat !== 'function' || (!regForm && !newsletterForm)) return;

        if (regForm) this.setupRegistrationTracking(document.getElementById('voltax-sign-in'));
        if (newsletterForm) this.setupNewsletterTracking(document.getElementsByClassName('bcForm')[0]);

        this.isAttached = true;
        if (this.observer) this.observer.disconnect();
      }

      init() {
        this.observer = new MutationObserver(() => this.attachListener());
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.attachListener();
      }
    }

    window.addEventListener("DOMContentLoaded", () => {
      new ChartbeatConversionEvents();
    });
  `;
